<template>
  <b-container :style="fundoTopo" fluid id="topo-pdf">
    <menuSite />
    <destaque />
  </b-container>
</template>

<script>
  import menuSite from './menu.vue'
  import destaque from './destaque.vue'
  import MainData from '@/main.js'
  export default {
    name: 'Topo',
    data() {
      return {
        client: null,
        fundoTopo: ''
      }
    },
    created() {
      let me = this
      me.client = MainData.CLIENT
      if (
        me.client === 'CUIABA' ||
        me.client === 'PMVG' ||
        me.client === 'PMM-AL' ||
        me.client === 'DOE-AL'
      ) {
        me.fundoTopo = { background: '#fff' }
      } else {
        me.fundoTopo = {
          backgroundImage:
            'url(' +
            require('@/assets/imagens/' + me.client + '/diariobg.jpg') +
            ')'
        }
      }
    },
    components: {
      menuSite,
      destaque
    }
  }
</script>

<style lang="scss">
  #topo-pdf {
    position: fixed;
    top: 0;
    height: 122px;
    background-size: cover;
    background-position: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/pdf/topo.vue